(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  $(function() {
    $('.product-images--panel').click(function() {
      $("#shopify-section-product-panel").show()
      $("#PageContainer").hide()
    })
    $(".panel-nav-back").click(function() {
      $("#shopify-section-product-panel").hide()
      $("#PageContainer").show()
    });
  })

  } catch(e) { console.error(e); }
})();
})();
